import { reducerFactory } from '@ackee/jerome';

import { supportedLanguages } from '../contants';

export const reducer = reducerFactory(supportedLanguages);
